import React, {useEffect, useCallback} from 'react'
import { useDispatch, useSelector } from "react-redux";

import moment from 'moment'
import {selectHolidays} from "../reducers/holidaySlice";
import {DateUtils} from "react-day-picker";
import {changeHolidayTheme} from "../reducers/themeSlice";


const withHolidayTheme = (AppComponent) => {

    const AppView = props => {
        const dispatch = useDispatch()

        const holidays = useSelector(selectHolidays)
        const {from , to} = useSelector(
            ({holiday, datePicker}) => ({
                from: datePicker.from,
                to: datePicker.to,
            })
        )

        const checkDateRangeWithinHoliday = useCallback((from, to) => {

            var holiday = holidays.find(item => {
                var holiday_date = moment(item.holiday_date, 'YYYY-MM-DD')
                var target_date, start_date, end_date;

                if(from && to){
                    target_date = holiday_date.toDate()
                    start_date = from
                    end_date = to
                }else{
                    var day = holiday_date.day()
                    target_date = moment().toDate()
                    start_date = holiday_date.clone().subtract(day, 'days').toDate()
                    end_date = holiday_date.toDate()
                }
                return item.alias != null && DateUtils.isDayInRange(target_date, {from: start_date, to:end_date})
            })

            var theme = holiday ? holiday.alias : ""
            dispatch(changeHolidayTheme(theme))
        },[holidays, dispatch])

        useEffect(() => {
            checkDateRangeWithinHoliday(from, to)
        }, [holidays, from, to])

        return (
            <AppComponent {...props}/>
        )
    }

    return AppView

}

export default withHolidayTheme